'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadGen = exports.mapStateToProps = exports.LeadGenUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _decorator = require('helpers/decorator');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _multitrack = require('helpers/multitrack');

var _user = require('redux/saga/selectors/user');

var _bound = require('redux/saga/entities/bound');

var _verify = require('helpers/verify');

var _LeadGenFormContainer = require('features/LeadGenForm/LeadGenFormContainer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

var LeadGenUnwrapped = exports.LeadGenUnwrapped = function (_Component) {
  (0, _inherits3.default)(LeadGenUnwrapped, _Component);

  function LeadGenUnwrapped(props) {
    var _this, _this2;

    (0, _classCallCheck3.default)(this, LeadGenUnwrapped);

    _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (LeadGenUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(LeadGenUnwrapped)).call(this, props)), _this2);

    _this2.hideModule = function () {
      return _this.setState({ shouldHide: true });
    };

    var hideOnLoad = _this2.props.hideOnLoad;


    _this2.state = {
      shouldHide: hideOnLoad
    };
    return _this2;
  }

  (0, _createClass3.default)(LeadGenUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Cms Page', 'View Module', 'LeadGen', 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.shouldHide) {
        return false;
      }

      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          canHide = _props.canHide,
          ctaCopy = _props.ctaCopy,
          singleLineBreakpoint = _props.singleLineBreakpoint,
          submissionType = _props.submissionType,
          subtitleCopy = _props.subtitleCopy,
          titleCopy = _props.titleCopy,
          useMarketingStyles = _props.useMarketingStyles,
          wasCaptured = _props.wasCaptured;


      var leadGenClasses = (0, _classnames2.default)('lead-gen', {
        'lead-gen--marketing': useMarketingStyles,
        'bg--light': backgroundColor === 'light',
        'bg--white': backgroundColor === 'white',
        'anim anim--fadeOut lead-gen--anim-delay': canHide && wasCaptured
      });

      return _react2.default.createElement(
        'div',
        {
          className: leadGenClasses,
          onAnimationEnd: canHide && wasCaptured ? this.hideModule : noop
        },
        _react2.default.createElement(
          'h2',
          { className: 'lead-gen__title' },
          titleCopy || _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'leadgen.title',
            defaultMessage: 'Find the best studios near you.'
          })
        ),
        _react2.default.createElement(
          'p',
          { className: 'lead-gen__subtitle' },
          subtitleCopy || _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'leadgen.subtitle',
            defaultMessage: 'Join the waitlist and be the first one to know when we\u2019re ready for launch.'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'lead-gen__form' },
          _react2.default.createElement(_LeadGenFormContainer.LeadGenFormContainer, {
            ctaCopy: ctaCopy,
            singleLineBreakpoint: singleLineBreakpoint,
            submissionType: submissionType
          })
        )
      );
    }
  }]);
  return LeadGenUnwrapped;
}(_react.Component);

LeadGenUnwrapped.propTypes = {
  backgroundColor: _propTypes2.default.oneOf(['white', 'light']),
  canHide: _propTypes2.default.bool,
  ctaCopy: _propTypes2.default.string,
  hideOnLoad: _propTypes2.default.bool,
  submissionType: _propTypes2.default.string,
  singleLineBreakpoint: _propTypes2.default.string,
  subtitleCopy: _propTypes2.default.string,
  titleCopy: _propTypes2.default.string,
  useMarketingStyles: _propTypes2.default.bool,
  wasCaptured: _propTypes2.default.bool
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, props) {
  var canHide = props.canHide;

  var wasCaptured = !(0, _verify.isEmpty)(_bound.waitlistRequest.data(state));
  return {
    hideOnLoad: (0, _user.isLoggedIn)(state) || !!(canHide && wasCaptured),
    wasCaptured: wasCaptured
  };
};

var LeadGen = exports.LeadGen = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), _TrackDwell2.default)(LeadGenUnwrapped);